export default __webpack_public_path__ + "static/media/featimgtwo.98673297.svg";